import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useGroupSlug } from "@/hooks/use-group-slug";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faFileXmark,
} from "@nnr/fontawesome-sharp-light/icons/sharp/light";
import * as Sentry from "@sentry/react";
import { LinkProps, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useCountdown } from "usehooks-ts";

export const NotFoundPage = () => {
  const navigate = useNavigate();
  const [counter, { startCountdown, stopCountdown }] = useCountdown({
    countStart: 10,
  });
  const [isCountingDown, setIsCountingDown] = useState(true);
  const groupSlug = useGroupSlug(false);

  const redirection: LinkProps = groupSlug
    ? { to: "/w/$groupSlug", params: { groupSlug } }
    : { to: "/u/workspaces" };

  useEffect(() => {
    startCountdown();
    Sentry.captureMessage("Page Not Found");
  }, []);

  useEffect(() => {
    if (counter === 0) {
      navigate({ ...redirection, replace: true });
    }
  }, [counter]);

  const stopCounter = () => () => {
    stopCountdown();
    setIsCountingDown(false);
  };

  return (
    <div
      className="bg-background flex h-full flex-col items-center justify-center p-4"
      onClick={stopCounter()}
    >
      <div className="flex flex-row gap-4">
        <FontAwesomeIcon icon={faFileXmark} size="6x" />
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-4">
            <div className="text-4xl">Oops!</div>
            <div className="text-2xl">Looks like this page wandered off.</div>
          </div>
          <Separator />
          <div className="flex flex-col items-start gap-4">
            <div>Maybe it's sipping coffee somewhere it shouldn't be.</div>
            <div>Let's get you back home before anyone notices.</div>
            <Button onClick={() => navigate({ ...redirection, replace: true })}>
              <FontAwesomeIcon icon={faArrowRight} />
              {isCountingDown ? (
                <>Redirecting in {counter} seconds...</>
              ) : (
                <>Redirect Now</>
              )}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
